var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 32 32",
    height: "32px",
    id: "Layer_1",
    viewBox: "0 0 32 32",
    width: "32px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pin_1_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.48,13.794c0-5.789-4.692-10.481-10.48-10.481c-5.789,0-10.481,4.692-10.481,10.481   c0,1.036,0.153,2.036,0.433,2.983c1.492,6.035,10.095,12.785,10.095,12.785s9.719-7.621,10.291-13.91l-0.025-0.005   C26.421,15.046,26.48,14.427,26.48,13.794z M16.143,16.128c-2.368,0-4.288-1.92-4.288-4.288c0-2.368,1.92-4.288,4.288-4.288   c2.367,0,4.287,1.92,4.287,4.288C20.43,14.208,18.51,16.128,16.143,16.128z",
    fill: "#515151"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocation);
export default __webpack_public_path__ + "static/media/icon-location.7ae68fb64994ac3b40b43ce3ef4bb628.svg";
export { ForwardRef as ReactComponent };